/**
 * @class
 * @deprecated
 */
import Base from './attribute_tag';

import {ids as attributeTypeIds} from '@netx/core-asset/properties/attributes';

export default class Attribute_Semantic extends Base {
	/** @type {object} */
	get defaults() {
		return {
			...super.defaults,
			type: attributeTypeIds.semantic,
		};
	}

	/** @type {string} */
	static get __name__() {
		return 'Attribute_Semantic';
	}
}
